import { useEffect } from 'react';
import { getConfig } from '../config/runtime-config';

/**
 * Hook to get the current application configuration
 */
export function useAppConfig() {
  try {
    return getConfig();
  } catch (error) {
    console.error('Failed to get config:', error);
    return {
      authProvider: 'azure',
      azureClientId: '',
      azureAuthority: '',
      oidcClientId: '',
      oidcAuthority: '',
      oidcScope: 'openid profile email',
      oidcSilentRedirectUri: `${globalThis.location.origin}/auth/silent-callback`,
      redirectUri: `${globalThis.location.origin}/auth/callback`,
      postLogoutRedirectUri: globalThis.location.origin,
      bolApiScope: '',
      appTitle: 'BOL Backoffice',
      debugMode: false,
    };
  }
}

/**
 * Hook to update the document title based on configuration
 */
export function useDocumentTitle(pageTitle?: string) {
  const config = useAppConfig();
  
  useEffect(() => {
    const title = pageTitle 
      ? `${pageTitle} | ${config.appTitle}` 
      : config.appTitle || 'BOL Backoffice';
    
    document.title = title;
  }, [config.appTitle, pageTitle]);
}
